import { localGet } from "@/utils/index";
function createCanvas(){
    var  bodyContainer = document.body;
    var width = 300;
    var height = 120;
    var x =0;
    var y =60;
    var rotate=-15;
    var fontSize =16;
    var alpha =0.04;//透明度
    var color='#'
    var canvas = document.createElement('canvas');
    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);

     var ctx = canvas.getContext("2d");

     ctx.textAlign = 'left';//设置或返回文本内容的当前对齐方式
     ctx.textBaseline = 'top';//在绘制文本时使用的当前文本基线
     ctx.font = `${fontSize}px Arial`//ctx.font = '24px Arial';
     ctx.fillStyle = color;
     ctx.globalAlpha = alpha;//设置或返回绘图的当前 alpha 或透明值
     ctx.rotate(Math.PI / 180 * rotate);//将画布旋转30度
     ctx.fillText(localGet("userid") + ' ' + localGet("email"), x, y);//从cookie里获取userName
     var base64Url = canvas.toDataURL();

     var wm = document.getElementById('waterMark');

     var watermarkDiv = wm || document.createElement("div");
     var styleStr = `
       position:fixed;
       top:0;
       left:0;
       bottom:0;
       right:0;
       z-index:${9999};
       pointer-events:none;
       background-repeat:repeat;
       background-image:url('${base64Url}')`;

     watermarkDiv.setAttribute('style', styleStr);
     watermarkDiv.id ='waterMark'

     if (!wm) {
       bodyContainer.appendChild(watermarkDiv)
     }
 
     const MutationObserver = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;//检测浏览器是否支持该特性
     if (MutationObserver) {
       var observer = new MutationObserver(function () {
         var wm = document.getElementById('waterMark');
         // 只在wm元素样式被修改或者元素被移除时
         if ((wm && wm.getAttribute('style') !== styleStr) || !wm) {
           // 避免一直触发
           observer.disconnect();
           observer = null;
           createCanvas()
         }
       });

       observer.observe(bodyContainer, { //监听body元素子元素的变化
         attributes: true,
         subtree: true,
         childList: true
       })
     }

    var styleEl =  document.createElement('style');
    styleEl.setAttribute('type','text/css');
    styleEl.innerText ='@media  print{ #waterMark{ display:none } }';
    document.head.appendChild(styleEl)
    // gwm.creation({
    //     txt:'13987654321',
    //     width: 198,
    //     height: 140,
    //     x: 20,
    //     y: 70,
    //     fontSize: 13,
    //     color: '#ff0000',
    //     watch: true,
    //     css: {'z-index': 9999}
    //     })
}

export { createCanvas }


